import { DocField } from '../FormDoc';

export class DocBooleanField extends DocField<boolean>
{
  public get asBool(): boolean
  {
    return this.getValue() ? true : false;
  }
}
